import { useEffect, useState, useContext } from 'react';
import axios from '../../util/Api';
import { ParamsContext } from '../Context/ParamsContext';
import Table from '../../components/Table/Basic';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';

const List = (props) => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [totalData, setTotalData] = useState(null);
  const params = useContext(ParamsContext);
  const { authUser } = useSelector(({ auth }) => auth);

  const columns = [
    {
      title: 'Nama Proyek',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      filter: true,
      visible: authUser.is_superadmin,
    },
    // {
    //   title: 'Divisi Operasi',
    //   key: 'division',
    //   // sorter: true,
    //   render: record => record.division.label
    // },
    {
      title: 'Kode Proyek',
      // dataIndex: 'code',
      key: 'code',
      sorter: true,
      filter: true,
      visible: authUser.is_superadmin,
      render: record => {
        return (
          <div>
            <div>{record.code}</div>
            <div className="gx-mt-1 gx-text-muted">
              {record.division.label}
            </div>
          </div>
        );
      }
    },
    {
      title: 'PM',
      dataIndex: 'manager',
      key: 'manager',
      sorter: true,
      filter: true,
    },
    {
      title: 'Email',
      // dataIndex: 'email',
      key: 'email',
      filter: true,
      render: record => {
        return (
          <>
            {record.email}
            <div className="gx-text-muted gx-mt-1">{record.phone}</div>
          </>
        );
      }
      // sorter: true
    },
    // {
    //   title: 'WA Admin',
    //   dataIndex: 'phone',
    //   key: 'phone',
    //   // sorter: true
    // },
    {
      title: 'Total Perusahaan',
      key: 'company',
      render: record => JSON.stringify(record.vendors)
    },
    {
      title: 'Total Teregistrasi',
      key: 'passport',
      render: record => record.passport.count
    },
    {
      title: 'Total Presence',
      key: 'tap',
      render: record => record.tap.summary
    },
    {
      title: 'Status',
      key: 'status',
      // sorter: true
      render: record => record.status.label
    },
    {
      title: '',
      key: 'action',
      width: 120,
      render: record => (
        <div className="gx-text-right">
          {authUser.is_superadmin ? <Link to={`/project/update?id=${record.id}`} className="gx-mr-1 ant-btn ant-btn-secondary ant-btn-sm">
            Edit
          </Link> : null}
          <Link to={`/project/detail?id=${record.id}`} className="ant-btn ant-btn-secondary ant-btn-sm">
            Detail
          </Link>
        </div>
      )
    },
  ];

  useEffect(() => {
    fetchList();
  }, [params]);

  const fetchList = () => {
    setLoading(true);
    const url = `/project/list`;
    axios.get(url, {params: params}).then(({ data }) => {
      setProjects(data.projects);
      setTotalData(data.total);
      setLoading(false);
    }).catch(err => {});
  }

  return (
    <Table
      columns={columns}
      dataSource={projects}
      loading={loading}
      total={totalData}
      pathname="/project"
    />
  );
}

export default List;